var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelegation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.0118C20 20.0804 20.4317 19.1872 21.2 18.5286C21.9684 17.87 23.0105 17.5 24.0971 17.5H25.2677C26.3543 17.5 27.3964 17.87 28.1647 18.5286C28.9331 19.1872 29.3647 20.0804 29.3647 21.0118C29.4078 21.7718 29.2028 22.5252 28.7806 23.1586C28.3583 23.792 27.7417 24.271 27.0236 24.5236C26.3054 24.8603 25.6888 25.499 25.2665 26.3435C24.8443 27.188 24.6393 28.1926 24.6824 29.2059M24.6824 33.8883V33.9",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 25C6.25 14.6447 14.6447 6.25 25 6.25C35.3553 6.25 43.75 14.6447 43.75 25C43.75 35.3553 35.3553 43.75 25 43.75C14.6447 43.75 6.25 35.3553 6.25 25Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegation);
export default __webpack_public_path__ + "static/media/delegation.bb40c7206a67e30ed4c04076726f03f2.svg";
export { ForwardRef as ReactComponent };